import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

export const getEstatesLookups = async () => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/estate/lookups`);
	return data;
};

export const getEstates = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/estate/list`, { params });
	return data;
};

export const getEstateDetail = async (slug) => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/estate/${slug}`);
	return data;
};

export const saveEstate = async (form, filters = {}) => {
	const payload = { form, filters };
	const { data } = await axios.post(`${API_GO}/app/maintainer/estate/save`, payload);
	return data;
};

export const deleteEstate = async (slug) => {
	const { data } = await axios.delete(`${API_GO}/app/maintainer/estate/${slug}`);
	return data;
};

export const getEstateOutData = async () => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/estate/out/data`);
	return data;
};

export const postEstateOutAll = async (params) => {
	const { data } = await axios.post(`${API}/admin/estates/out_all`, params);
	return data;
};
